import { updateFolder } from 'owa-folders';
import setFolderField from 'owa-service/lib/factory/setFolderField';
import deleteFolderField from 'owa-service/lib/factory/deleteFolderField';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import RetentionTagType from 'owa-service/lib/contract/RetentionTagType';
import folder from 'owa-service/lib/factory/folder';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import { ARCHIVE_TAG_FIELD_URI } from '../utils/retentionPolicyConstants';

/**
 *
 * @param folderId id of the folder to be updated
 * @param fieldURI contains the URI to be updated
 * @param tag tag to be updated
 */
export default function updateFolderRetentionPolicy(
    folderId: string | DistinguishedFolderIdName,
    fieldURI: string,
    tag: RetentionTagType
): Promise<FolderInfoResponseMessage> {
    const folderFieldData = {
        Path: propertyUri({
            FieldURI: fieldURI,
        }),
        Folder: tag
            ? fieldURI === ARCHIVE_TAG_FIELD_URI
                ? folder({ ArchiveTag: tag })
                : folder({ PolicyTag: tag })
            : null, // If no explicit tag is selected we do not want to set the Folder property
    };
    const propertyUpdates = [
        tag ? setFolderField(folderFieldData) : deleteFolderField(folderFieldData),
    ];
    return updateFolder(folderId, propertyUpdates);
}
